import { DriverList } from './driver-list';

export const PROVIDER_ADDRESS_CATEGORY = "4";
export const HOME_ADDRESS_CATEGORY = "6";
export const TRIP_RATE = .25;

export interface TripRequestsByTypeModel {
  preTripRequests: TripRequestGroup[];
  postTripRequests: TripRequestGroup[];
  paymentGroups: PaymentGroup[];
  consumerName: string;
}

export interface TripRequestGroup {
  requestStatus: string;
  tripRequests: TripRequest[];
}

export interface TripRequest {
  requestId: number;
  recipientId: number;
  tripType: boolean;
  dueDate: Date;
  submissionDate: Date | null;
  tripRequestStatusName: string;
  tripRequestStatusId: number;
  appointmentDate: Date;
  expenseType: ExpenseType;
  expenseAmount: number;
  confirmationNo: string;
  cancelable: boolean;
}

export interface PaymentGroup {
  paymentStatus: string;
  payments: TripRequestPayment[];
}

export interface TripRequestPayment {
  recipientId: number;
  requestId: number;
  submittedDate: Date | null;
  amountDue: number;
  paymentStatusId?: number | null;
  confirmationNo: string;
}

export enum ExpenseType {
  Toll = 'Toll',
  Parking = 'Parking',
}

export enum TripRequestStatus {
  Unsubmitted = 7,
  SubmittedByConsumer = 2,
  Returned = 14
}

export enum TripRequestType {
  Pre = 'Pre',
  Post = 'Post',
}

export enum TripQueueMapping {
  SubmittedByAgency = 1,
  SubmittedByConsumer = 2,
}

export interface TripRequestDto {
  tripRequestId: number;
  recipientId: number;
  tripType: TripRequestType;
  tripRequestStatusId: number;
  isSameDriver?: boolean;
  driverId?: number | null;
  driverFirstName?: string;
  driverLastName?: number;
  driverMannualEntry?: boolean;
  saveDriverIntoProfile?: boolean;
  samePassenger?: boolean;
  anotherMedicaidConsumer?: boolean;
  appointmentTypeId?: number | null;
  appointmentType?: string;
  isRoundTrip?: boolean;
  tripAuthorize?: boolean;
  appointmentDocumentUploading?: boolean;
  appointmentDocumentEmailing?: boolean;
  appointmentDocumentMailing?: boolean;
  appointmentDocumentFaxing?: boolean;
  tollDocumentUploading?: boolean;
  tollDocumentEmailing?: boolean;
  tollDocumentMailing?: boolean;
  tollDocumentFaxing?: boolean;
  parkingDocumentUploading?: boolean;
  parkingDocumentEmailing?: boolean;
  parkingDocumentMailing?: boolean;
  parkingDocumentFaxing?: boolean;
  tripRate?: number;
  invalidManualAddress?: boolean;
  invalidEligibility?: boolean;
  queueStatusMappingId?: number | null;
  expenseAmount?: number;
  stepIndex: number;
  isAcceptedPreTrip?: boolean;
  isSameAgentWillReview?: boolean;
  tripAppointments?: TripAppointmentDto[];
  tripAddresses?: TripAddressDto[];
  tripPassengers?: TripPassengerDto[];
  tripDocuments?: TripDocumentsDto[];
  verificationDocuments?: VerificationDocuments[];
}

export interface TripAppointmentDto {
  appointmentId: number;
  appointmentDate: Date;
  appointmentTime: Date;
  saveDriverIntoProfile?: boolean;
  enteredTotalMiles?: number;
  enteredReimbursementAmount?: number;
  enteredTotalReimbursementAmount?: number;
  driverId?: number | null;
  driverMannualEntry?:boolean;
  explanationText?: string;
  appointmentDriver?: DriverList;
  appointmentPassengers?: TripPassengerDto[];
  tripExpenses?: TripExpenseDto[];
  tripLegs?: TripLegsDto[];
}

export interface TripAddressDto {
  tripAddressId: number;
  addressCategoryId: string;
  seqNo: number;
  address: string;
  providerOrNickName?: string;
  otherCategoryType?: string;
  isManualAddress: boolean;
  saveAddress: boolean;
  isMapAddress: boolean;
}

export interface TripPassengerDto {
  passengerId: number;
  firstName: string;
  lastName?: string;
}

export interface documentDto {
  documentUploading: boolean;
  documentEmailing: boolean;
  documentMailing: boolean;
  documentFaxing: boolean;
}

export interface TripPassengerDto {
  passengerId: number;
  firstName: string;
  lastName?: string;
}

export interface TripExpenseDto {
  expenseId: number;
  expenseType: string;
  expenseAmount: number;
}

export interface TripDocumentsDto {
  documentId: number;
  fileName: string;
  path: string;
  documentType: string;
  file?: File;
  linkDocumentId?: number;
}

export interface TripLegsDto {
  legId: number;
  seqNo: number;
  fromAddressId: number;
  toAddressId: number;
  shortestMiles: number;
  enteredMiles?: number;
  approvedMiles?: number;
}

export interface ExportTripRequestsToExcelConsumerDashboard {
  tripRequestType?: string | null;
  tripRequestStatusId?: number | null;
  paymentStatusId?: number | null;
  exportType?: string | null;
}

export interface TripRequestAddressCategoryModel {
  categoryId: string;
  categoryName: string;
}

export interface TripRequestInfo {
  requestId: number;
  mode:string;
}

export interface VerificationDocuments {
  tripRequestId: number;
  confirmationNumber:string;
  fileNames: string;
  fileNamesWithId: string;
}
